import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconPhoto = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      d="M4.002 8a2 2 0 0 1 2-2h11.996a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.002a2 2 0 0 1-2-2V8Z"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      d="m20.22 16.438-3.286-2.89a1.106 1.106 0 0 0-1.434 0l-1.843 1.621-4.266-3.753a1.106 1.106 0 0 0-1.434 0L3.69 15.17"
      vectorEffect="non-scaling-stroke"
    />
    <circle
      cx={13.911}
      cy={8.778}
      r={1.911}
      stroke="currentColor"
      strokeLinejoin="round"
      transform="rotate(-45 13.91 8.778)"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const Memo = memo(SvgIconPhoto);
export default Memo;
